var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-config-provider',{attrs:{"locale":_vm.locale},scopedSlots:_vm._u([{key:"renderEmpty",fn:function(){return [_c('div',{staticClass:"div-align"},[_c('a-empty',{attrs:{"image":_vm.simpleImage,"description":'暂无数据'}})],1)]},proxy:true}])},[_c('div',{attrs:{"id":"app"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }